﻿import $ from "jquery";
import "summernote/dist/summernote-lite.min.js";
import "summernote/dist/summernote-lite.min.css";

export class TextEditor {

    private defaultDescriptionText =
        "<p>An dieser Stelle haben Sie die Möglichkeit Ihre Zuschauer zu begrüßen und die Agenda, sowie die Eckpunkte Ihres Events einzufügen.</p><p><b><br></b></p><p><b>Agenda</b></p><p><span style='font-size: 1rem; text - align: inherit; font - weight: 400; '>- Punkt 1</span></p><p><span style='font - size: 1rem; text - align: inherit; font - weight: 400; '>-&nbsp;</span><span style='font - size: 1rem; text - align: inherit; font - weight: 400; '>Punkt 2</span></p><p><span style='font - size: 1rem; text - align: inherit; font - weight: 400; '>-&nbsp;</span><span style='font - size: 1rem; text - align: inherit; font - weight: 400; '>Punkt 3</span></p><p><span style='font - size: 1rem; text - align: inherit; font - weight: 400; '><br></span></p><table class='table table - bordered'><tbody><tr><td>Datum des Events:</td><td>01.05.2021 | 16:00 - 19:00 Uhr</td></tr><tr><td>Moderator(en):</td><td>Namen der Moderatoren</td></tr><tr><td>Weitere Informationen:</td><td>Sie können beliebig viele weitere Punkte hinzufügen</td></tr></tbody></table>";

    /*
     * editorElementId - Id of div element in which the editor will be placed
     * editorElementInputId - Id of the hidden input element bound to the page model
     */
    public init(editorElementId: string, editorElementInputId: string): void {
        $(`#${editorElementId}`).summernote({
            callbacks: {
                onChange: (contents) => {
                    // Update hidden input bound to page model
                    $(`#${editorElementInputId}`).val(contents);
                }
            },
            placeholder: "Beschreibungstext",
            tabsize: 2,
            height: 200,
            toolbar: [
                ["font", ["bold", "underline", "clear"]],
                ["color", ["color"]],
                ["para", ["paragraph"]],
                ["table", ["table"]],
                ["insert", ["link"]],
                ["view", ["codeview"]]
            ]
        });

        // Initialize editor with value given in input bound to page model
        const initialValue = $(`#${editorElementInputId}`).val();
        if (initialValue !== undefined && initialValue !== null && initialValue.toString().length > 0) {
            $(`#${editorElementId}`).summernote("code", initialValue.toString());
        }
        else {
            $(`#${editorElementId}`).summernote("code", this.defaultDescriptionText);
        }
    }
}